<template>
  <async-loader
    v-if="contentLoading"
  />
  <simple-copy
    v-else-if="content && content.length"
    :content="content"
  />
</template>

<script>
  import SimpleCopy from '@sections/SimpleCopy'
  import AsyncLoader from '@molecules/AsyncLoader'

  export default {
    components: { AsyncLoader, SimpleCopy },
    props: {
      content: {
        type: String
      },
      contentLoading: {
        type: Boolean,
        default: true
      }
    }
  }
</script>
